export const orbEntities = {
  RESERVATION: 'TicketSeller::Reservation',
  TICKET: 'TicketSeller::Ticket',
  RESERVATION_PAYMENT: 'Financial::ReservationPayment',
  RESERVATION_REFUND: 'Financial::ReservationRefund',
  TICKET_BALANCE_TRANSFER: 'Financial::PartPaymentTicketTransfer',
  ADVANCE_RESERVATION_PAYMENT: 'Financial::AdvanceReservationPayment',
  ADVANCE_RESERVATION_REFUND: 'Financial::AdvanceReservationRefund'
}
